import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            内容分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            八大内容分类，总有一款适合你。点击进入浏览海量资源
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-50 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-accent-100 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl text-accent-600`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 font-label whitespace-nowrap">
                  {cat.name}
                </h3>
                <span className="text-xs text-foreground-500 mt-0.5 block">
                  {cat.count.toLocaleString()} 部作品
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}